import {
  PERFORMANCE_DEFAULT_SORTING,
  storesPerformanceExportHeaders,
} from "../../../constants/shared/performanceFilter.constants";

export const individualGroupPerformanceConstants = {
  ALL_GROUP_RESPONSE_DATA: "ALL_GROUP_RESPONSE_DATA",
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA: "CUSTOMER_RESPONSES_EXPORT_ALL_DATA",
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING:
    "STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING",
};

export const individualGroupPerformanceDefaultSorting =
  PERFORMANCE_DEFAULT_SORTING;

export const individualGroupPerformanceExportHeaders =
  storesPerformanceExportHeaders;
